import React from 'react';

import classnames from 'classnames/bind';
import styles from './messageContents.module.scss';
const cx = classnames.bind(styles);

interface MessageContentsProps {
  title: string;
  message: string;
}

const MessageContents = ({ title, message }: MessageContentsProps) => {
  return (
    <>
      <strong className={cx('title')}>{title}</strong>
      <div className={cx('message')}>{message}</div>
    </>
  );
};

export default MessageContents;
